export * from './mo-record.component';
